module.exports = __webpack_public_path__ + "img/header_8.b0a300b7.jpg";